import {PushNotifications} from '@capacitor/push-notifications'
import $router from '@/router/index'

export default {
    /**
     * When the user opens the app by tapping a push (FCM) notification from outside
     * the app, navigate to the in-app notifications screen.
     */
    registerNavigateOnNotificationOpen(){
        void PushNotifications.addListener('pushNotificationActionPerformed', ({ actionId }) => {
            if (actionId !== 'tap'){
                return;
            }
            $router.push({ name: 'notifications' }).catch(() => {});
        });
    },
    /**
     * Fetches the push token once per call. Listeners are removed after the first
     * registration or registrationError — repeated login/register must not stack
     * listeners or each register() will invoke every prior callback (Capacitor).
     */
    getDeviceToken(successCallback, errorCallback){
        (async ()=>{
            let registrationHandle;
            let errorHandle;
            let settled = false;

            const cleanup = async ()=>{
                await Promise.all([
                    registrationHandle ? registrationHandle.remove().catch(()=>{}) : Promise.resolve(),
                    errorHandle ? errorHandle.remove().catch(()=>{}) : Promise.resolve(),
                ]);
            };

            try{
                const permission = await PushNotifications.requestPermissions();
                if (permission.receive !== 'granted'){
                    errorCallback('NOT_GRANTED');
                    return;
                }

                registrationHandle = await PushNotifications.addListener('registration', async (token)=>{
                    if (settled){
                        return;
                    }
                    settled = true;
                    await cleanup();
                    successCallback({token: token.value});
                });

                errorHandle = await PushNotifications.addListener('registrationError', async (error)=>{
                    if (settled){
                        return;
                    }
                    settled = true;
                    await cleanup();
                    errorCallback(error);
                });

                await PushNotifications.register();
            }catch (err){
                await cleanup();
                errorCallback(err);
            }
        })();
    },
}
